import DataTable from 'components/Tables/DataTable'
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import { Routes, Route } from 'react-router-dom'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import { LeadsTable } from './components/LeadsTable'
import { Box, Card, Grid, Typography } from '@mui/material'

export const LeadsList = () => {
  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
        pb={6}
      >
        <Grid item xs={12} mb={2} mt={6}>
          <Typography
            variant="h1"
            fontWeight="600"
            fontSize="28px"
            textAlign="left"
            color="#262627"
          >
            PARCO Data Cleanup
          </Typography>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Card
              sx={{
                textAlign: 'left',
                boxShadow: 0,
                borderRadius: 2,
                border: '1px solid #D2D6DA',
              }}
            >
              <div data-testid="leadsTableContainer">
                <LeadsTable />
              </div>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </DashboardLayout>
  )
}
